module.exports = __webpack_public_path__ + "img/7.c26f27d3.png";